/* eslint-disable */
import React, { useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { EmployeeListTable } from 'src/components/employee-list-table';
import { useTypedSelector } from 'src/hooks/useTypedSelector';
import Arrow from 'src/assets/arrow-left-black.svg';
import { Select, MenuItem, FormControl, Button, Typography, IconButton } from '@mui/material';
import { SearchInput } from 'pg-ui-library';
import useDebounce from 'src/hooks/useDebounce';
const employeeListInitialColumns = [
  { name: 'First Name', selector: (row: { firstName: any }) => row.firstName, width: '140px', omit: false },
  { name: 'Middle Name', selector: (row: { middleName: any }) => row.middleName, width: '140px', omit: false },
  { name: 'Last Name', selector: (row: { lastName: any }) => row.lastName, width: '140px', omit: false },
  { name: 'Gender', selector: (row: { gender: any }) => row.gender, width: '100px', omit: false },
  { name: 'Birth Date', selector: (row: { birthDate: any }) => row.birthDate, width: '150px', omit: false },
  { name: 'Employee Class', selector: (row: { employeeClass: any }) => row.employeeClass, width: '130px', omit: false },
  { name: 'Hire Date', selector: (row: { hireDate: any }) => row.hireDate, width: '150px', omit: false },
  {
    name: 'Personnel Number',
    selector: (row: { personnelNumber: any }) => row.personnelNumber,
    width: '150px',
    omit: false,
  },
  { name: 'City', selector: (row: { city: any }) => row.city, width: '130px', omit: false },
  { name: 'State', selector: (row: { state: any }) => row.state, width: '100px', omit: false },
  { name: 'Zip Code', selector: (row: { zipCode: any }) => row.zipCode, width: '130px', omit: false },
  {
    name: 'Is Active',
    selector: (row: { isActive: any }) => (row.isActive ? 'Yes' : 'No'),
    width: '100px',
    omit: false,
  },
  {
    name: 'Is New Hire',
    selector: (row: { isNewHire: any }) => (row.isNewHire ? 'Yes' : 'No'),
    width: '120px',
    omit: false,
  },
  { name: 'Is QLE', selector: (row: { isQle: any }) => (row.isQle ? 'Yes' : 'No'), width: '120px', omit: false },
  {
    name: 'Is Benefit Update',
    selector: (row: { isBenefitUpdate: any }) => (row.isBenefitUpdate ? 'Yes' : 'No'),
    width: '150px',
    omit: false,
  },
  {
    name: 'New Hire Activate date',
    selector: (row: { newHireActivatedAt: any }) => {
      if (!row.newHireActivatedAt) return '';
      const date = new Date(row.newHireActivatedAt);
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    },
    width: '220px',
    omit: false,
  },
  {
    name: 'QLE Activate date',
    selector: (row: { qleActivatedAt: any }) => {
      if (!row.qleActivatedAt) return '';
      const date = new Date(row.qleActivatedAt);
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    },
    width: '170px',
    omit: false,
  },
  {
    name: 'Updated At',
    selector: (row: { updatedAt: any }) => {
      if (!row.updatedAt) return '';
      const date = new Date(row.updatedAt);
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    },
    width: '170px',
    omit: false,
  },
];
const Newhirelist = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [benefitType, setBenefitType] = useState('Enable');
  const [searchTerm, setSearchTerm] = useState('');
  const { config } = useTypedSelector(state => state.config.data);
  const companyId = config?.selectedCompanyId;
  const enableGlobalSearchSend = true;
  const debouncedSearchTerm = useDebounce(searchTerm, 500);
  const filteredStatus = useMemo(() => {
    return benefitType === 'Enable' ? true : false;
  }, [benefitType]);
  return (
    <div
      style={{
        maxWidth: 2300,
        margin: '42px auto',
        background: '#fff',
        borderRadius: '18px',
        boxShadow: '0 4px 32px 0 rgba(112,130,255,0.13)',
        padding: '34px 36px 32px 36px',
        minHeight: '66vh',
      }}
    >
      <div style={{ display: 'flex', marginBottom: 32 }}>
        <IconButton
          onClick={() => navigate(-1)}
          sx={{ marginRight: 1.5, color: '#373A90', background: '#F7F9FB', borderRadius: '50%' }}
        >
          <img src={Arrow} alt="Back" style={{ width: 21, height: 21 }} />
        </IconButton>
        <Typography sx={{ fontWeight: 600, fontSize: 22, color: '#23235F', letterSpacing: '0.05px' }}>
          New hire Users List
        </Typography>
      </div>
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: 24 }}>
        <span style={{ fontWeight: 500, color: '#23235F', fontSize: 17 }}>New Hire User</span>
        <FormControl sx={{ minWidth: 210, mx: 2 }}>
          <Select
            value={benefitType}
            onChange={e => setBenefitType(e.target.value)}
            size="small"
            sx={{ background: '#F7F9FB', borderRadius: '6px', fontSize: '15px' }}
          >
            <MenuItem value="Enable">Enable</MenuItem>
            <MenuItem value="Disable">Disable</MenuItem>
          </Select>
        </FormControl>
        <SearchInput
          value={searchTerm}
          placeholder="Search..."
          handleChange={event => {
            let newValue = event.target.value;
            newValue = newValue.replace(/[',.]/g, '');
            setSearchTerm(newValue);
          }}
        />
      </div>
      <div style={{ marginTop: 8 }}>
        {companyId && (
          <EmployeeListTable
            searchTerm={debouncedSearchTerm}
            companyId={companyId}
            columns={employeeListInitialColumns}
            employeeStatus={filteredStatus ? '1' : '0'}
            enableGlobalSearch={enableGlobalSearchSend}
          />
        )}
      </div>
    </div>
  );
};
export default Newhirelist;
